
import React from "react";
import {
  Modal, Fade, Typography, Box, Backdrop, Button,
  IconButton, InputBase
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useState } from "react";
import { useEffect } from "react";
import { MoneyFormat, MoneyFormatv2 } from "../../library/MoneyFormat";
import { showSuccessSnackbar, showWarningSnackbar } from "../snackBar/snakbar";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import { listInvoiceDenominations } from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  // p: 4,
  outline: "none",
  display: "flex",
  flexDirection: "column",
  maxHeight: "90%",
  overflow: "hidden"
};



const EnterDenomination = forwardRef(({ open, setOpen, total, receivedAmount, edit, updateRecievedAmount }, ref) => {
  console.log({ total, edit })
  const InitalDenomination = [
    { Denomination: 2000, Number_Of_Notes: "", notes: "" },
    { Denomination: 500, Number_Of_Notes: "", notes: "" },
    { Denomination: 200, Number_Of_Notes: "", notes: "" },
    { Denomination: 100, Number_Of_Notes: "", notes: "" },
    { Denomination: 50, Number_Of_Notes: "", notes: "" },
    { Denomination: 20, Number_Of_Notes: "", notes: "" },
    { Denomination: 10, Number_Of_Notes: "", notes: "" },
    { Denomination: 5, Number_Of_Notes: "", notes: "" },
    { Denomination: 2, Number_Of_Notes: "", notes: "" },
    { Denomination: 1, Number_Of_Notes: "", notes: "" },
  ]

  const [AmountCollected, setAmountCollected] = useState(JSON.parse(JSON.stringify(InitalDenomination)))
  const [AmountReturned, setAmountReturned] = useState(JSON.parse(JSON.stringify(InitalDenomination)))
  const [Amounts, setAmounts] = useState({ amountCollected: 0, amountReturned: 0, amountReceived: 0 })

  const [Applied, setApplied] = useState({
    status: false,
    AmountCollected: JSON.parse(JSON.stringify(AmountCollected)),
    AmountReturned: JSON.parse(JSON.stringify(AmountReturned)),
    Amounts
  })

  const handleClose = (event, reason) => {
    console.log({ event, Applied, Amounts, AmountCollected, AmountReturned })
    if (event !== true) {
      console.log('updated')
      setAmountCollected(JSON.parse(JSON.stringify(Applied.AmountCollected)))
      setAmountReturned(JSON.parse(JSON.stringify(Applied.AmountReturned)))

    }
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  }

  const reset = () => {
    setAmountCollected(JSON.parse(JSON.stringify(InitalDenomination)))
    setAmountReturned(JSON.parse(JSON.stringify(InitalDenomination)))
  }
  const handleChange = (type, index, e) => {
    const name = e?.target?.name
    const value = parseInt(e.target.value) > 0 ? parseInt(e.target.value) : ''
    console.log(name, value, type)
    console.log(AmountCollected, AmountReturned)

    if (type === 'Collected') {
      let temp = [...AmountCollected]
      temp[index][name] = value
      if (value >= 0) {
        temp[index]["notes"] = parseInt(value * temp[index]["Denomination"]) > 0 ? value * temp[index]["Denomination"] : ''
      } else {
        temp[index]["notes"] = ""
      }
      setAmountCollected([...temp])
    }
    else if (type === 'Returned') {
      let temp = [...AmountReturned]
      temp[index][name] = value
      if (value >= 0) {
        temp[index]["notes"] = parseInt(value * temp[index]["Denomination"]) > 0 ? value * temp[index]["Denomination"] : ''
      }
      else {
        temp[index]["notes"] = ""
      }
      setAmountReturned([...temp])
    }
  }
  const totalAmountCollected = () => {
    let totalAmountCollected = 0
    for (var i = 0; i < AmountCollected.length; i++) {
      totalAmountCollected += parseInt(AmountCollected[i]?.Number_Of_Notes) >= 0 ? parseInt(AmountCollected[i]?.Denomination) * parseInt(AmountCollected[i]?.Number_Of_Notes >= 0 ? AmountCollected[i]?.Number_Of_Notes : 0) : 0

    }
    let totalAmountReturned = 0
    for (var i = 0; i < AmountReturned.length; i++) {
      totalAmountReturned += parseInt(AmountReturned[i]?.Number_Of_Notes) >= 0 ? parseInt(AmountReturned[i]?.Denomination) * parseInt(AmountReturned[i]?.Number_Of_Notes >= 0 ? AmountReturned[i]?.Number_Of_Notes : 0) : 0
    }
    console.log(AmountReturned, AmountCollected, totalAmountCollected, totalAmountReturned)
    setAmounts({ amountCollected: totalAmountCollected, amountReturned: totalAmountReturned, amountReceived: totalAmountCollected - totalAmountReturned })
  }
  const fetchDenomination = async () => {

    const res = await API.graphql(
      graphqlOperation(listInvoiceDenominations, { InvoiceID: edit.id })
    );
    console.log(res.data)
    let collected = []
    let returned = []
    let AmountReturned = 0
    let AmountCollected = 0
    let NetAmount = 0
    if (res?.data?.listInvoiceDenominations && res?.data?.listInvoiceDenominations.length === InitalDenomination.length * 2) {
      res?.data?.listInvoiceDenominations.map((elem) => {
        if (elem.TypeCD == "Collected") {
          AmountCollected = +elem?.Number_Of_Notes > 0 ? elem.Denomination * elem.Number_Of_Notes : 0
          collected = [...collected, { Denomination: elem.Denomination, Number_Of_Notes: elem.Number_Of_Notes > 0 ? elem.Number_Of_Notes : "", notes: elem?.Number_Of_Notes > 0 ? elem.Denomination * elem.Number_Of_Notes : "" },]
        } else if (elem.TypeCD == "Returned") {
          returned = [...returned, { Denomination: elem.Denomination, Number_Of_Notes: elem.Number_Of_Notes > 0 ? elem.Number_Of_Notes : "", notes: elem?.Number_Of_Notes > 0 ? elem.Denomination * elem.Number_Of_Notes : "" },]
          AmountReturned = +elem?.Number_Of_Notes > 0 ? elem.Denomination * elem.Number_Of_Notes : 0

        }
      })

      NetAmount = AmountCollected - AmountReturned
      // setAmounts({ amountCollected: AmountCollected, amountReceived: NetAmount, amountReturned: AmountReturned })

      const sortByDenom = (a, b) => b.Denomination - a.Denomination;


      setAmountReturned(JSON.parse(JSON.stringify(returned.slice().sort(sortByDenom))))
      setAmountCollected(JSON.parse(JSON.stringify(collected.slice().sort(sortByDenom))))
      setApplied({
        status: true,
        AmountReturned: JSON.parse(JSON.stringify(returned.slice().sort(sortByDenom))),
        AmountCollected: JSON.parse(JSON.stringify(collected.slice().sort(sortByDenom))),
        // Amounts: { amountCollected: AmountCollected, amountReceived: NetAmount, amountReturned: AmountReturned }
      })
    }


    console.log(res)
  }
  useEffect(() => {
    if (edit?.id) {
      fetchDenomination()
    }

    return () => {

    }
  }, [edit])

  useEffect(() => {
    console.log(Applied)

    return () => {

    }
  }, [Applied])


  useEffect(() => {

    totalAmountCollected()
    return () => {

    }
  }, [AmountCollected, AmountReturned])

  const apply = (show) => {
    console.log(parseFloat(receivedAmount), parseFloat(Amounts.amountReceived))
    // if (parseFloat(receivedAmount) !== parseFloat(Amounts.amountReceived)) {
    //   if (open) {
    //     setdialog(true)
    //   } else {
    //     // showWarningSnackbar("Received Amount and Net Amount Received should be same !")
    //     // setOpen(true)
    //   }
    //   return false
    // } else {
    if (show) {
      showSuccessSnackbar("Applied")
      setApplied({
        status: true,
        AmountCollected: JSON.parse(JSON.stringify(AmountCollected)),
        AmountReturned: JSON.parse(JSON.stringify(AmountReturned)),
        // Amounts
      })
      handleClose(true)
      // }
    }
    return true
  }

  const getValue = () => {
    if (apply(false)) {
      return { AmountCollected: Applied.AmountCollected, AmountReturned: Applied.AmountReturned, Amounts: Applied.Amounts }
    } else {
      return false
    }
  }
  useImperativeHandle(ref, () => ({
    getValue
  }));
  const [block, setblock] = useState(false)
  const [dialog, setdialog] = useState(false)
  const [closeDialog, setcloseDialog] = useState(false)
  const test = () => {
    setblock(!block)
  }
  const modalClose = () => {
    let res = false
    Object.keys(Applied["AmountCollected"]).forEach((keys) => {
      Object.keys(Applied["AmountCollected"][keys]).forEach((keyss) => {
        if (Applied["AmountCollected"][keys][keyss] !== AmountCollected[keys][keyss]) {
          console.log(Applied["AmountCollected"][keys][keyss], AmountCollected[keys][keyss])
          setcloseDialog(true)
          res = true
          return
        } else {
          console.log(Applied["AmountCollected"][keys][keyss], AmountCollected[keys][keyss])
        }
      })
    })
    Object.keys(Applied["AmountReturned"]).forEach((keys) => {
      Object.keys(Applied["AmountReturned"][keys]).forEach((keyss) => {
        if (Applied["AmountReturned"][keys][keyss] !== AmountReturned[keys][keyss]) {
          console.log(Applied["AmountReturned"][keys][keyss], AmountReturned[keys][keyss])
          setcloseDialog(true)
          res = true
          return
        } else {
          console.log(Applied["AmountReturned"][keys][keyss], AmountReturned[keys][keyss])
        }
      })
    })
    console.log({ Applied, AmountCollected, AmountReturned })
    if (!res) {
      handleClose()
    }
  }
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>

          <Box sx={style}>
            <Box sx={{
              backgroundColor: "primary.main",
              padding: "10px",
              display: "flex",
              flexDirection: "row",
            }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ color: "#fff", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  Enter Denomination
                  <IconButton aria-label="delete"
                    onClick={modalClose}
                  >
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            <Box sx={{ overflowY: "scroll" }}>
              <Box sx={{ display: 'flex', padding: "15px", paddingBottom: "0px" }}>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ color: "#bccb8b", fontSize: '12px' }}>Invoice Total</Typography>
                  <Typography sx={{ fontSize: "25px" }}><span style={{ fontSize: "12px", color: "#bccb8b" }}  >₹ </span>{total}</Typography>
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ color: "#bccb8b", fontSize: '12px' }}>Received Amount</Typography>
                  <Typography sx={{ fontSize: "25px" }}><span style={{ fontSize: "12px", color: "#bccb8b" }}  >₹ </span>{MoneyFormat(receivedAmount)}</Typography>
                </Box>

               
              </Box>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
                <Box sx={{ padding: "15px", flex: 1 }}>
                  <Typography sx={{ color: "red", fontWeight: "bold", fontSize: "12px" }}>Amount Collected: ₹ {MoneyFormat(Amounts.amountCollected)}</Typography>
                  <Box sx={{
                    '.css-17nc4jk-MuiTableCell-root': {
                      border: '1px solid #80808024'
                    },
                    '.MuiTableCell-root': {
                      padding: '5px 10px',
                      fontSize: '13px'
                    },

                  }}
                  >
                    <TableContainer>
                      <Table sx={{}} size="small" aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#057d86' }}>
                          <TableRow size="small" sx=
                            {{}}>
                            <TableCell sx={{ height: '5px', width: "100px", color: "#fff", fontSize: "13px" }}>Denomination</TableCell>
                            <TableCell sx={{ height: '5px', width: "100px", color: "#fff", fontSize: "13px" }}>Number of Notes</TableCell>
                            <TableCell sx={{ height: '5px', width: "100px", color: "#fff", fontSize: "13px" }}>Amounts</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {AmountCollected.map((elem, index) => {
                            return <TableRow>
                              <TableCell size="small" sx={{
                                border: '1px solid #80808024', m: 1
                              }}>{elem.Denomination}</TableCell>
                              <TableCell sx={{
                                border: '1px solid #80808024', m: 1
                              }}><InputBase type="number" name="Number_Of_Notes" size="small" onChange={(e) => handleChange("Collected", index, e)} value={elem.Number_Of_Notes} /></TableCell>
                              <TableCell sx={{
                                border: '1px solid #80808024', m: 1
                              }}><InputBase name="notes" size="small" onChange={(e) => handleChange("Collected", index, e)} disabled value={elem.notes} /></TableCell>
                            </TableRow>
                          })}


                          <TableRow>
                            <TableCell size="small" sx={{
                              border: '1px solid #80808024', m: 1
                            }}>Total</TableCell>

                            <TableCell colSpan={2} sx={{
                              border: '1px solid #80808024', m: 1
                            }}>{MoneyFormat(Amounts.amountCollected)}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
                {/* <Box sx={{ padding: "15px", flex: 1 }}>
                  <Typography sx={{ color: 'red', fontWeight: "bold", fontSize: "13px", }}>Amount Returned:</Typography>
                  <Box sx={{
                    '.css-17nc4jk-MuiTableCell-root': {
                      border: '1px solid #80808024'
                    },
                    '.MuiTableCell-root': {
                      padding: '5px 10px',
                      fontSize: '13px'
                    },
                  }}>
                    <TableContainer>
                      <Table size="small" sx={{}} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#057d86' }}>
                          <TableRow >
                            <TableCell sx={{ height: '5px', width: "100px", color: "#fff", fontSize: "13px", }}>Denomination</TableCell>
                            <TableCell sx={{ height: '5px', width: "100px", color: "#fff", fontSize: "13px", }} >Number of Notes</TableCell>
                            <TableCell sx={{ height: '5px', width: "100px", color: "#fff", fontSize: "13px", }} >Amounts</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {AmountReturned.map((elem, index) => {
                            return <TableRow>
                              <TableCell size="small" sx={{
                                border: '1px solid #80808024', m: 1
                              }}>{elem.Denomination}</TableCell>
                              <TableCell sx={{
                                border: '1px solid #80808024', m: 1
                              }}><InputBase type="number" name="Number_Of_Notes" size="small" onChange={(e) => handleChange("Returned", index, e)} value={elem.Number_Of_Notes} /></TableCell>
                              <TableCell sx={{
                                border: '1px solid #80808024', m: 1
                              }}><InputBase name="notes" size="small" disabled onChange={(e) => handleChange("Returned", index, e)} value={elem.notes} /></TableCell>
                            </TableRow>
                          })}
                          <TableRow>
                            <TableCell size="small" sx={{
                              border: '1px solid #80808024', m: 1
                            }}>Total</TableCell>

                            <TableCell colSpan={2} sx={{
                              border: '1px solid #80808024', m: 1
                            }}>{MoneyFormatv2(Amounts.amountReturned)}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box> */}
              </Box>
            </Box>
            <Box sx={{ padding: "10px" }}>
              {Amounts.amountCollected - receivedAmount > 0 && <Typography sx={{ color: "", fontWeight: "600", fontSize: "13px" }}>Balance To Be Returned :<Typography component="span" sx={{ color: "#000000de", fontWeight: "600", fontSize: "13px" }}>₹ {MoneyFormat(Amounts.amountCollected - receivedAmount)}</Typography></Typography>}

            </Box>
            <Box sx={{
              // padding : "15px",
              // width:'100%',
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'row' }
            }}>
              {/* <Button onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '10px', fontSize: "12px" }} >Cancel</Button> */}
              <Button onClick={reset} variant='contained' sx={{ flex: 1, margin: '10px', fontSize: "12px" }} >Reset</Button>
              <Button onClick={() => apply(true)} variant='contained' sx={{ flex: 1, margin: '10px', fontSize: "12px" }} >Apply</Button>
            </Box>

          </Box>
        </Fade>


      </Modal>
      {/* <AlertDialog open={dialog} handleClose={() => { setdialog(false) }}
        onYes={() => {
          console.log(typeof (updateRecievedAmount))
          if (typeof (updateRecievedAmount === "function")) {
            updateRecievedAmount(Amounts.amountReceived)
            setApplied({
              status: true,
              AmountCollected: JSON.parse(JSON.stringify(AmountCollected)),
              AmountReturned: JSON.parse(JSON.stringify(AmountCollected)),
              // Amounts
            })
            setOpen(false);
          }
        }}

        text={<Typography>The Recieved Amount and the Net Recieved amount does not match !<br />
          Do you want to update the Recieved amount from <b>{MoneyFormat(receivedAmount)}</b> to <b>{MoneyFormat(Amounts.amountReceived)}</b> ?

        </Typography>
        }
      /> */}
      <AlertDialog open={closeDialog} handleClose={() => {
        setcloseDialog(false)
      }
      }
        text="Do you want to discard you changes ?"
        onYes={handleClose}
      />
    </>

  );
})

export default EnterDenomination;


function AlertDialog({ open, handleClose, onYes, onNo, text }) {
  return (

    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onBackdropClick={false}
    >
      <DialogTitle id="alert-dialog-title">
        Warning
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          if (onNo && typeof (onNo) === 'function') {
            onNo()
            if (handleClose && typeof (handleClose) === 'function') {
              handleClose()
            }
          } else {
            if (handleClose && typeof (handleClose) === 'function') {
              handleClose()
            }
          }
        }}>No</Button>
        <Button onClick={() => {
          if (onYes && typeof (onYes) === 'function') {
            onYes()
            if (handleClose && typeof (handleClose) === 'function') {
              handleClose()
            }
          } else {
            if (handleClose && typeof (handleClose) === 'function') {
              handleClose()
            }
          }
        }} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

